import type { JSX } from 'react'
import type { IButtonGroupProps } from '../ButtonGroup'

import { ButtonGroup } from '../ButtonGroup'
import { PaymentFormButtonGroupSC } from '../ButtonGroup.styled'

export interface IPaymentFormButtonGroupProps extends IButtonGroupProps {}

export const PaymentFormButtonGroup = ({
  children,
  width = 100,
  ...rest
}: IPaymentFormButtonGroupProps): JSX.Element => (
  <PaymentFormButtonGroupSC columnGap={rest.columnGap}>
    <ButtonGroup width={width} {...rest}>
      {children}
    </ButtonGroup>
  </PaymentFormButtonGroupSC>
)
